import request from 'umi-request';

export async function queryValidateConnection(connectionId, callbackData = null) {
  // Si hay callbackData, es un callback (sin connectionId en URL)
  // Si no hay callbackData, es validación normal (con connectionId en URL)
  const url = callbackData ? '/connection/validate' : `/connection/validate/${connectionId}`;

  return request(url, {
    method: 'POST',
    data: callbackData || {}, // Para callback envía los datos, para validación normal envía objeto vacío
  });
}

export async function queryAuthorizeConnection(connectionType, connectionId, redirectUri) {
  const params = redirectUri ? { redirectUri } : {};
  return request(`/connection/authorize/${connectionType}/${connectionId}`, {
    method: 'GET',
    params,
  });
}
